import Component from '@glimmer/component';

import { array } from '@ember/helper';
import { service } from '@ember/service';

import Step from 'rise-ui/components/step.gjs';
import Sticky from 'rise-ui/components/sticky.gjs';
import WizardSteps from 'rise-ui/components/wizard-steps.gjs';
import currentRoute from 'rise-ui/helpers/current-route.js';
import indexOf from 'rise-ui/helpers/index-of.js';
import string from 'rise-ui/helpers/string.js';

export default class StepsStickyLargeComponent extends Component {
  @service('time-series/selected-locations') selectedLocations;
  @service('time-series/outputs') outputs;

  <template>
    {{#let
      (indexOf
        (currentRoute name=true)
        (array "time-series.search" "time-series.selection" "time-series.output")
      )
      as | routeIndex |
    }}
    <Sticky @name="wizard-step--large" @type="large-wizard">
      <WizardSteps as | wizard |>
        <wizard.Step
          @route="time-series.search"
          @complete={{this.selectedLocations.count}}
        >
          {{string "time-series-search-route"}}
          <wizard.StepDescription>
            <Step @step="0" @index={{routeIndex}} class="c-sticky__action--state" />
          </wizard.StepDescription>
        </wizard.Step>

        <wizard.Step
          @route="time-series.selection"
          @complete={{this.outputs.count}}
        >
          {{string "time-series-selection-route"}}
          <wizard.StepDescription>
            <Step @step="1" @index={{routeIndex}} class="c-sticky__action--state" />
          </wizard.StepDescription>
        </wizard.Step>

        <wizard.Step @route="time-series.output" @last="true">
          {{string "time-series-output-route"}}
          <wizard.StepDescription>
            <Step @step="2" @index={{routeIndex}} class="c-sticky__action--state" />
          </wizard.StepDescription>
        </wizard.Step>
      </WizardSteps>
    </Sticky>
    {{/let}}
  </template>
}
